import { Store } from 'hooks/useStore'

export const campaignStore = new Store()
export const adventureStore = new Store()
export const sceneryStore = new Store()